var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoBrowsing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2279 2.079L30.3315 9.80823C31.0271 10.3403 30.7511 11.4461 29.8871 11.5891L26.922 12.0797L29.2072 16.2014C29.4726 16.6799 29.304 17.2829 28.829 17.5544L27.2195 18.4746C26.7356 18.7513 26.1189 18.5789 25.8486 18.0914L23.5761 13.9927L21.6521 16.2809C21.0827 16.9581 19.979 16.6165 19.8916 15.736L18.6252 2.97198C18.5388 2.1014 19.533 1.54744 20.2279 2.079Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5512 10.8278L2.09106 21.9798C1.43775 22.6156 1.90622 23.7225 2.81742 23.6961L6.9608 23.5761L5.01155 28.5705C4.79856 29.1162 5.09817 29.7273 5.66003 29.8932L8.3131 30.6762C8.81119 30.8232 9.33892 30.5645 9.52774 30.0807L11.539 24.9274L14.9626 27.3732C15.6569 27.8692 16.6135 27.3237 16.5402 26.4735L15.2449 11.4585C15.1724 10.618 14.1558 10.2394 13.5512 10.8278Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoBrowsing);
export default __webpack_public_path__ + "static/media/co-browsing.0464d9963560655cf2a8dae212d77f8e.svg";
export { ForwardRef as ReactComponent };